import logo from './logo.svg';
import './App.css';
import Navbar from './Components/Navbar';
import HeroSection from './Components/HeroSection';
import Products from './Components/Products';
import ProductIngredients from './Components/ProductIngredients';
import AboutUs from './Components/AboutUs';
import ContactUs from './Components/ContactUs';
import Footer from './Components/Footer';

function App() {
  return (
    <div className="App">
      <Navbar/>
   <div id="home"><HeroSection /></div>
      <div id="products"><Products /></div>
      <div id="ingredients"><ProductIngredients /></div>
      <div id="about"><AboutUs /></div>
      <div id="contact"><ContactUs /></div>
      <div id="footer"><Footer /></div>
    </div>
  );
}

export default App;
